<template>
  <div class="onboarding-facetec-error">
    <Icon class="alert-icon" name="error"/>

    <p class="onboarding-error-message">
      Infelizmente a versão do seu navegador não suporta o envio da selfie.
    </p>

    <p class="onboarding-instructions-message">
      Entre em contato com nosso suporte para prosseguirmos com sua compra:
    </p>

    <div class="onboarding-error-buttons">
      <Button @click="handleEmailClick">
        <Icon name="outline-mail" />
        <span class="gray-700">atendimento@parcelex.com.br</span>
      </Button>

      <p class="body-regular gray-500">OU</p>

      <Button class="primary" @click="handleWppClick">
        <Icon name="outline-wpp" />
        <span>(21) 97155-6988</span>
      </Button>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/ui/AppIcon.vue';
import Button from '@/components/ui/AppButton.vue';

export default {
  name: 'onboarding-facetec-error',
  components: { Icon, Button },
  methods: {
    handleEmailClick() {
      window.location.href = 'mailto:atendimento@parcelex.com.br';
    },
    handleWppClick() {
      window.location.href = 'https://api.whatsapp.com/send?phone=5521971556988';
    },
  },
};
</script>

<style lang="scss" scoped>
  .onboarding-facetec-error {
    height: 100vh;

    display: flex;
    flex-direction: column;

    margin: 0 24px;
    align-items: center;

    .alert-icon {
      margin-top: 48px;
    }

    .onboarding-error-message {
      @extend .small-regular;

      color: var(--gray-700);
      text-align: center;

      margin: 16px 0 24px 0;
    }

    .onboarding-instructions-message {
      @extend .small-regular;

      font-weight: 600;
      color: var(--gray-700);
      text-align: center;

      margin-bottom: 24px;
    }

    .onboarding-error-buttons {
      display: flex;
      flex-direction: column;
      gap: 16px;

      align-items: center;

      width: 100%;

      button {
        height: 48px;
        width: 100%;
      }

      span {
        font-weight: 600;
        margin-left: 10px;
      }
    }
  }
</style>
